import { render, staticRenderFns } from "./CmsEditor.vue?vue&type=template&id=0f33b535&scoped=true&"
import script from "./CmsEditor.vue?vue&type=script&lang=js&"
export * from "./CmsEditor.vue?vue&type=script&lang=js&"
import style0 from "./CmsEditor.vue?vue&type=style&index=0&id=0f33b535&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f33b535",
  null
  
)

export default component.exports